


























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import dayjs from 'dayjs'
import AdminCreateTicketDialog from '@/modules/ticket/components/admin/AdminCreateTicketDialog.vue'
import { TicketResourceModel } from '@/modules/ticket/models/ticket-resource.model'
import { TicketAnswerUpdateUseCase } from '@/modules/ticket-answer/use-cases/admin/ticket-answer-update.use-case'
import { AdminTicketAnswerService } from '@/modules/ticket-answer/services/admin-ticket-answer.service'
import { TicketAnswerCollectionModel } from '@/modules/ticket-answer/models/ticket-answer-collection.model'
import MediaList from '@/modules/media/components/shared/MediaList.vue'
import { TicketStoreRequestModelInAdmin } from '@/modules/ticket/models/ticket-request.model'

@Component({
  components: {
    MediaList,
    BaseButton
  }
})
export default class TicketAnswerList extends Vue {
  constructor(
    private readonly ticketAnswerUpdateUseCase: TicketAnswerUpdateUseCase,
    private readonly ticketAnswerService: AdminTicketAnswerService
  ) {
    super()
  }

  @Prop({ default: false }) noActions: boolean
  @Prop({ required: true }) ticketResource: TicketResourceModel
  private dialog = null

  protected formatDate(date: string) {
    return dayjs(date).format('D MMMM YYYY , HH:mm')
  }

  openDialog(index) {
    this.dialog = this.$q.dialog({
      component: AdminCreateTicketDialog,
      label: 'ویرایش تیکت',
      isLoading: this.ticketAnswerUpdateUseCase.isLoading,
      ticket: {
        department_id: this.ticketResource.department.id,
        file: this.ticketResource.answers[index].attachments,
        message: this.ticketResource.answers[index].message,
        status: this.ticketResource.status,
        title: this.ticketResource.title,
        user_id: this.ticketResource.answers[index].user.id
      }
    }).onOk((request: TicketStoreRequestModelInAdmin) => {
      this.onSubmit(request, index)
    })
  }

  onSubmit(request, index) {
    this.dialog.update({ isLoading: true })
    this.ticketAnswerUpdateUseCase.execute(this.ticketResource.id, this.ticketResource.answers[index].id, request)
      .then(() => {
        if (this.ticketAnswerUpdateUseCase.isSuccess) {
          this.dialog.hide()
        }
        this.dialog.update({ isLoading: false })
      })
  }

  destroy(index) {
    this.ticketAnswerService.destroy(this.ticketResource.id, this.ticketResource.answers[index].id)
  }

  isAgentAnswer(item: TicketAnswerCollectionModel) {
    return this.ticketResource.user.id !== item.user.id
  }

}
